import { ContentAreaLayout } from "@talladega/types";

export const ContentArea = ({ contentDetails }: ContentAreaLayout) => {
  return (
    <div className="mx-auto max-w-page items-center gap-6 py-2 lg:gap-24">
      <div
        className="text-base font-normal lg:text-lg lg:leading-6"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: contentDetails,
        }}
      />
    </div>
  );
};

export default {};
